'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UISearchInput from 'UIComponents/input/UISearchInput';
import UIHeader from 'UIComponents/layout/UIHeader';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { filterAccounts } from '../actions';

class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.onFilterAccounts = this.onFilterAccounts.bind(this);
  }

  onFilterAccounts(e) {
    this.props.filterAccounts(e.target.value);
  }

  render() {
    return /*#__PURE__*/_jsx(UIHeader, {
      use: "condensed",
      title: I18n.text('main.header'),
      children: /*#__PURE__*/_jsx(UISearchInput, {
        onChange: this.onFilterAccounts,
        placeholder: I18n.text('main.searchText')
      })
    });
  }

}

Header.propTypes = {
  filterAccounts: PropTypes.func
};
export default connect(() => ({}), {
  filterAccounts
})(Header);